module.exports = __webpack_public_path__ + "media/images/1200/healthy-589097477e1c3ceba86fc6af6c2430d1.jpg";